<template>
  <div>

    <form @submit.prevent="getUsers" v-show="step == 0">
      <p class="text-muted">Introduce tu {{ pageCountry == 'mexico' ? 'CURP' : 'Documento Nacional de Identidad' }} para recuperar tu usuario</p>

      <div class="form-group mb-5">
        <FloatingLabel type="text" input-class="form-control form-control-xl bg-light-2 border-0" :label="pageCountry == 'mexico' ? 'CURP' : 'Documento Nacional de Identidad'" v-model="document" />
      </div>

      <div class="text-center">
        <a href="#" class="text-blue-ml font-weight-bold mr-3" @click.prevent="$emit('changeModal', 'login')">Atrás para iniciar sesión</a>
        <button type="submit" class="btn btn-blue-ml px-4" :disabled="!disabledForm">Usuario de búsqueda</button>
      </div>
    </form>



    <div v-show="step == 1">
      <h2 class="text-black">Encontramos {{ foundUsers.length }} usuarios vinculados a su {{ pageCountry == 'mexico' ? 'CURP' : 'Documento Nacional de Identidad' }}</h2>
      <p class="h5 font-weight-normal mb-4">¿Qué usuario desea recuperar?</p>
      <small class="">Enviaremos el código al teléfono registrado.</small>

      <div class="row mt-2">
        <div class="col-12 mb-3" v-for="(user, index) in foundUsers" :key="index">
          <button
            class="btn btn-white d-flex align-items-center text-left border border-light-dark p-3 w-100"
            @click="selectedUser = user; sendSms()">
            <img v-if="user.avatar" :src="user.avatar">
            <account-circle-icon v-else class="img text-blue-ml" />
            <div class="ml-3">
              <h5 class="m-0">{{ user.name }}</h5>
              <p class="m-0">Correo electrónico: {{ $helpers.censorEmail(user.email) }}</p>
              <p class="m-0" v-if="user.profile.phone">Teléfono móvil: {{ $helpers.censorPhone(user.profile.phone) }}</p>
              <p class="m-0" v-if="!user.profile.phone">Móvil: No informado</p>
            </div>
          </button>
        </div>
      </div>
    </div>



    <form @submit.prevent="validateToken" v-show="step == 2">
      <h2 class="text-black" v-if="selectedUser">Enviamos un código al número {{ $helpers.censorPhone(selectedUser.profile.phone) }}</h2>
      <p class="h5 font-weight-normal mb-5">Introdúcelo a continuación para recuperar tu nombre de usuario</p>

      <div class="d-flex flex-column justify-content-center form-group mb-5">
        <FloatingLabel type="text" input-class="form-control form-control-xl bg-light-2 border-0" label="Código" v-model="token" v-mask="'######'" />
        <Countdown class="align-self-center" :time="timer" :key="componentKey"/>
      </div>

      <div class="d-flex align-items-center content-buttons-valid-token">
        <a href="#" class="text-blue-ml font-weight-bold mr-3 disabled" @click="sendSms()" id="resend">Reenviar codigo!</a>
        <button type="submit" class="btn btn-blue-ml px-4" @click="validateToken()" :disabled="token.length < 5">Validar código</button>
      </div>
    </form>



    <form @submit.prevent="resetEmail" v-show="step == 3">
      <h2 class="text-black">¿Cuál será tu nuevo correo electrónico?</h2>
      <p class="h5 font-weight-normal mb-5"></p>

      <div class="form-group mb-5">
        <FloatingLabel type="email" input-class="form-control form-control-xl bg-light-2 border-0" label="Nuevo Email" v-model="newEmail" />
      </div>

      <div class="text-center">
        <button type="submit" class="btn btn-blue-ml px-4">Recuperar usuario</button>
      </div>
    </form>



  </div>
</template>

<script>
  import FloatingLabel from '@/components/FloatingLabel';
  import AccountCircleIcon from "vue-material-design-icons/AccountCircle.vue";
  import Countdown from "ninenine-white-label/src/components/Countdown/Countdown.vue";
  import { mapState } from 'vuex'


  export default {
    name: 'ForgotUser',

    data(){
      return {
        step: 0,
        document: '',
        foundUsers: [],
        selectedUser: null,
        token: '',
        newEmail: '',
        timer: null,
        componentKey: 0
      }
    },

    components: {
      FloatingLabel,
      AccountCircleIcon,
      Countdown
    },

    computed: {
      disabledForm(){
        return this.document.length > 5
      },

      pageCountry(){
        if(this.$route.fullPath.includes('brasil')) {
          return 'brasil'
        } else if(this.$route.fullPath.includes('mexico')) {
          return 'mexico'
        }
      }
    },

    mounted(){
      this.timer = 120
      this.initListeners();
    },

    methods: {
      async getUsers(){
        this.$store.commit('DEVISE_LOADING', true);

        this.$store.dispatch("graphql_queries/query", `
          users(passport: "${ this.document }" ){
            id,
            email,
            name,
            avatar,
            profile{
              phone
            }
          }
        `).then( results => {
          if(results.users && results.users.length >= 1){
            this.foundUsers = results.users;
            this.step = 1;
          }else{
            this.$swal({
              title: 'Uoops',
              text: 'Este documento no está registrado',
              type: 'error',
              showCancelButton: true,
              cancelButtonText: 'No',
              confirmButtonText: 'Si, quiero registrarme',
              reverseButtons: true
            }).then((result) => {
              if (result.value) {
                this.$store.commit('DEVISE_TRYING', { document: this.cpf });
                this.$store.commit('DEVISE_FORM', 'register')
              }
            })
          }

          this.$store.commit('DEVISE_LOADING', false);
        });
      },

      async sendSms(){
        let el = document.getElementById('resend')
        this.$store.commit('DEVISE_LOADING', true);
        const sendSms = await this.$store.dispatch('user/generateTokenChangeEmail', { id: this.selectedUser.id }).catch(() => {});
        if(!sendSms || sendSms.error){
          this.$swal('Uoops', 'Hubo un problema al enviar el código a su teléfono móvil. Vuelva a intentarlo más tarde.', 'error');
          this.$store.commit('DEVISE_LOADING', false);
          return;
        }
        this.step = 2;
        if(el) el.classList.add('disabled');
        this.componentKey += 1;
        this.$store.commit('DEVISE_LOADING', false);
      },

      async validateToken(){
        this.$store.commit('DEVISE_LOADING', true);
        const validTokenEmail = await this.$store.dispatch('user/validTokenEmail', { id: this.selectedUser.id, token: this.token }).catch(() => {});
        if(!validTokenEmail || validTokenEmail.error || validTokenEmail.data.validTokenEmail.valid == false){
          this.$swal('Uoops', 'Había un problema. Verifique que el token ingresado sea correcto y vuelva a intentarlo.', 'error');
          this.$store.commit('DEVISE_LOADING', false);
          return;
        }
        this.step = 3;
        this.$store.commit('DEVISE_LOADING', false);
      },

      async resetEmail(){
        this.$store.commit('DEVISE_LOADING', true);
        const changeEmail = await this.$store.dispatch('user/changeEmail', { id: this.selectedUser.id, token: this.token, email: this.newEmail }).catch(() => {});
        if(!changeEmail || changeEmail.error){
          this.$swal('Uoops', 'Había un problema. Asegúrese de que el correo electrónico que ingresó sea correcto y vuelva a intentarlo.', 'error');
          this.$store.commit('DEVISE_LOADING', false);
          return;
        }
        this.$swal('',"Su correo electrónico ha sido cambiado con éxito.", "success");
        this.$store.commit('DEVISE_LOADING', false);
        this.$store.commit('DEVISE_FORM', 'login');
      },

      initListeners(){
        this.$EventBus.$on('finalCountdown', ()=>{
          let el = document.getElementById('resend')
          if(el) el.classList.remove('disabled');
        })
      },

    },
  }
</script>

<style lang="scss" scoped>
  img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }

  .notice{
    font-size: 12px;
    display: inline-flex;

  }

  /deep/.countdown{
    font-size: 10px !important;
    /deep/p{
      margin-bottom: 0 !important;
    }
    .text-danger{
      color: black !important;
    }
  }

  .img{
    font-size: 50px;
  }

  .content-buttons-valid-token{
    a{
      font-size: 12px;
      &.disabled{
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }
</style>